import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import { KBLinks } from 'features/constants';
import { AsyncStatusType, MAX_ITEMS_LIMIT } from 'features/files/fincen-reporting/constants';
import { FC } from 'react';
import AgentNetButton from 'ui-kit/components/button/AgentNetButton';
import PageHeader from 'ui-kit/components/headers/PageHeader';
import LoadingSpinner from 'ui-kit/components/LoadingSpinner';
import ContentContainer from 'ui-kit/components/utility/ContentContainer';
import { Transferor } from '../types';
import TransferorAccordion from './components/TransferorAccordion';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    accordionContainer: {
      width: '100%',
      padding: theme.spacing(0, 3, 0),
    },
  }),
);

interface TransferorInformationContentProps {
  transferors: Transferor[];
  onAddTransferor: () => void;
  onUpdateTransferor: (transferor: Transferor, index: number) => void;
  onDeleteTransferor: (index: number) => void;
  loadingStatus?: AsyncStatusType;
  isReadOnly?: boolean;
}

const TransferorInformationContent: FC<TransferorInformationContentProps> = ({
  transferors,
  loadingStatus,
  onAddTransferor,
  onUpdateTransferor,
  onDeleteTransferor,
  isReadOnly = false,
}) => {
  const classes = useStyles();

  return (
    <div
      style={{ pointerEvents: isReadOnly ? 'none' : 'auto', opacity: isReadOnly ? 0.6 : 1 }}
      tabIndex={isReadOnly ? -1 : undefined}
      onKeyDown={(e) => isReadOnly && e.preventDefault()}
    >
      <ContentContainer fullWidth mTop="0">
        <PageHeader
          title="Transferor Information"
          subtitle="The report must include information about the transferor individual, entity and/or trust involved. Multiple transferors may be recorded."
          menuItems={[
            {
              label: 'Knowledge Base',
              link: KBLinks.fincenReport,
            },
          ]}
          divider={true}
          contentRight={
            <AgentNetButton
              color="primary"
              size="small"
              variant="contained"
              data-testid="fincen-transferor-add-button"
              onClick={onAddTransferor}
              plusIcon
              disabled={transferors.length >= MAX_ITEMS_LIMIT}
            >
              Add Transferor
            </AgentNetButton>
          }
        />
        <LoadingSpinner status={loadingStatus || 'idle'} variant="linear" />
        <div className={classes.accordionContainer}>
          {transferors.map((transferor, index) => (
            <Box key={transferor.id} mb={2}>
              <TransferorAccordion
                key={transferor.id}
                transferor={transferor}
                index={index}
                onUpdate={(updated: Transferor) => onUpdateTransferor(updated, index)}
                onDelete={transferors.length > 1 ? () => onDeleteTransferor(index) : undefined}
              />
            </Box>
          ))}
        </div>
      </ContentContainer>
    </div>
  );
};

export default TransferorInformationContent;
